<template>
  <a-social-sharing
    hashtags="finance_magnates,fm"
    twitter-user="finance_magnates"
    network="reddit"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
  >
    <a-icon
      v-bind="$attrs"
      is-button
      tabindex="-1"
      :icon="$attrs.icon || ICON.SOCIAL_SQUARE_REDDIT"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'WhatsApp',
  mixins: [socialSharing]
}
</script>
